import { bindDisclosures } from './site-chrome-disclosure';

export default () => {
  bindDisclosures(document.querySelector('#site-chrome-header'));
  bindDisclosures(document.querySelector('#site-chrome-footer'));
};
